import { render } from "./TitleAndBiography.vue?vue&type=template&id=124b0d56&scoped=true"
import script from "./TitleAndBiography.vue?vue&type=script&lang=js"
export * from "./TitleAndBiography.vue?vue&type=script&lang=js"

import "./TitleAndBiography.vue?vue&type=style&index=0&id=124b0d56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124b0d56"]])

export default __exports__